import Vue from 'vue';
import VueRouter from 'vue-router';
import iView from 'view-design';
import Qs from "qs";
import util from '@/libs/util'

import Setting from '@/setting';
import Axios from "axios";

import store from '@/store/index';

// 路由数据
import routes from './routes';

let unNumber = {
    NotifysUndefind: 0,
    receviceNureadNumber: 0,
    SPunread: 0
}


Vue.use(VueRouter);

// 导出路由 在 main.js 里使用
const router = new VueRouter({
    routes,
    mode: Setting.routerMode,
    base: Setting.routerBase
});

//↓↓↓↓↓↓↓↓↓↓ 解决重复点击路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx". 开始 ↓↓↓↓↓↓↓↓↓↓//
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const jsonToFormData = (data) => {
    data = Qs.stringify(data, {arrayFormat: "brackets"}); // qs.stringify(params)
    return data;
}
// 获取审批的未读消息
const getSPunread = () => {
    let formData = new FormData();
    formData.append("def.key_$VRHK", 'sp_');
    // Axios
    //     .post("/jx12333Api/bpm/my/todoTaskList", formData).then(res => {
    //         unNumber.SPunread = res.data.total
    //         store.commit("admin/menu/setMenuBadge", [
    //             "/bpm/my/sp/todoTaskList/sp_",
    //             { path: "/bpm/my/sp/todoTaskList/sp_", badge: res.data.total },
    //         ]);
    //     })
}

/**
 * 路由拦截
 * 权限验证
 */

router.beforeEach((to, from, next) => {
    if (Setting.showProgressBar) iView.LoadingBar.start();
    //记录上一个路由
    store.dispatch('changPrevRouteAction',from)
    // 判断是否需要登录才可以进入
    if (to.matched.some(_ => _.meta.auth)) {
        // 这里依据 token 判断是否登录，可视情况修改
        const token = util.cookies.get('token');
        if (token && token !== 'undefined') {
            let foristLogin = localStorage.getItem('foristLogin');
            // 如果foristLogin 为 true 则表示是第一次登录 需要修改密码 为false则不需要修改密码 修改完成后才可以跳出当前页面
            // let foristLogin = localStorage.getItem('foristLogin');
            // if (foristLogin) {
            //     if (to.name === 'password') {
            //         next();
            //     } else {
            //         next({
            //             name: 'password'
            //         });
            //     }
            // } else {
            //     next();
            // }
            next();

        } else {
            // 没有登录的时候跳转到登录界面
            // 携带上登陆成功之后需要跳转的页面完整路径
            next({
                name: 'login',
                query: {
                    redirect: to.fullPath
                }
            });
        }
    } else {
        // 不需要身份校验 直接通过
        next();
    }
});

router.afterEach(to => {
    getSPunread()
    localStorage.setItem('unNumber', JSON.stringify(unNumber))
    store.dispatch('changAcUnread', unNumber)
    if (Setting.showProgressBar) iView.LoadingBar.finish();
    // 多页控制 打开新的页面
    store.dispatch('admin/page/open', to);
    /*   没有用，注释掉 @author csy
    // 更改标题
      util.title({
           //title: to.meta.title
           title: `待办${to.meta.title}`
       });*/
    // 返回页面顶端
    window.scrollTo(0, 0);
});

export default router;
